import styled from "@emotion/styled";
import {PC, Mobile} from "../../../../hooks/util/useMediaquery";

import SelectFreePhotoPC from "./PC/SelectFreePhoto"
import SelectFreePhotoMobile from "./Mobile/SelectFreePhoto";

const Elem:React.FC<any> = () => {
  return (
    <>
      <PC>
        <SelectFreePhotoPC />
      </PC>

      <Mobile>
        <SelectFreePhotoMobile />
      </Mobile>
    </>
  )
};

export default Elem;